import { companyId, userId } from 'helpers/userSessionSettings';
import supportsLocalStorage from 'helpers/supportsLocalStorage';
import { COMPANY_SCOPED_KEY_PATTERN } from 'helpers/buildStorageKeyFor';

const LAST_SESSION_ID_KEY = '__cwo_last_session_id__';

const PRESERVED_GLOBAL_KEYS = new Set([
  'theme',
  'oldDesignModal',
  'show_map_draw_hints',
  'field_monitoring/charts_view_mode',
  'lastSelectedLayer',
  'assetChecklists/lastSelectedAssetChecklistView',
  'tickets_dashboard_visible_columns',
  'tickets_dashboard_column_filters',
  'tickets_dashboard_user_filter',
  'tickets_dashboard_status',
]);

const shouldPurgeKey = (key) => (
  key !== LAST_SESSION_ID_KEY
  && !PRESERVED_GLOBAL_KEYS.has(key)
  && !COMPANY_SCOPED_KEY_PATTERN.test(key)
);

const purgeUnscopedLocalStorageKeys = () => {
  const allKeys = Array.from(
    { length: localStorage.length },
    (_, i) => localStorage.key(i),
  ).filter((key) => typeof key === 'string');

  for (const key of allKeys.filter(shouldPurgeKey)) {
    localStorage.removeItem(key);
  }
};

const cleanStaleLocalStorageOnSessionSwitch = () => {
  if (!supportsLocalStorage()) return;
  if (companyId == null || userId == null) return;

  try {
    const currentSessionId = `c-${companyId}--u-${userId}`;
    const lastSessionId = localStorage.getItem(LAST_SESSION_ID_KEY);
    if (lastSessionId === currentSessionId) return;

    purgeUnscopedLocalStorageKeys();
    localStorage.setItem(LAST_SESSION_ID_KEY, currentSessionId);
  } catch {
    /* empty */
  }
};

cleanStaleLocalStorageOnSessionSwitch();
